import Vue from 'vue';
import VueRouter from 'vue-router';
// import Index from '../views/Home.vue';
// import Contact from '../views/Contact.vue';

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/test',
  //   name: 'Index',
  //   component: Index
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  // {
  //   path: '/contact',
  //   name: 'Contact',
  //   component: Contact,
  // },
  {
    path: '/',
    name: 'HomeIndex',
    component: () => import(/* webpackChunkName: "sample" */'@/views/Home/Index'),
  },
  {
    path: '/skills',
    name: 'SkillsIndex',
    component: () => import(/* webpackChunkName: "sample" */'@/views/Skills/Index'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
